// extracted by mini-css-extract-plugin
module.exports = {"categories-form-table":"categories-form-table-3988176441631d57c8eefb81170feb0f","add-group-pictrue":"add-group-pictrue-6240176070416352b7b784ed7e351b7e"};